import React from "react";
/** composants **/
import { Navbar } from '../Navbar';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
//img & icon
import FaqPma from "../components/FaqPma";
import PrendreRdv from "./prendreRdv";
import BackHeaderTop from "../components/BackHeaderTop";
import BackHeaderBottom from "../components/BackHeaderBottom";
import GoogleAvis2 from '../img/google-avis-2.png';
import PmaImg from '../img/pma-lead.webp';
import { ArrowRightIcon, ChatBubbleBottomCenterIcon, CurrencyEuroIcon, DocumentCheckIcon, ScaleIcon, CheckIcon } from "@heroicons/react/24/solid";
import AccompagnementClotere from '../components/AccompagnementClotere'

const posts = [
    {
        id: 1,
        title: 'Les avantages juridiques pour les deux parents',
        href: 'https://clotere.framer.website/blog/les-avantages-juridiques-d-une-reconnaissance-conjointe-d-enfant-pour-les-deux-membres-du-couple',
        category: { title: 'Avantages reconnaissance conjointe enfant' },
    },
    {
        id: 2,
        title: 'Liste complète des documents nécessaires.',
        href: 'https://clotere.framer.website/blog/les-documents-n%C3%A9cessaires-chez-le-notaire-pour-la-reconnaissance-conjointe-d-enfant',
        category: { title: 'Documents reconnaissance conjointe anticipée' },
    },
    {
        id: 3,
        title: 'Les étapes d\'une RCA chez le notaire.',
        href: 'https://clotere.framer.website/blog/etapes-de-votre-reconnaissance-conjointe-d-enfant-chez-le-notaire',
        category: { title: 'Etapes d\'une reconnaissance conjointe d\'enfant' },
    },
    {
        id: 4,
        title: 'Démarches chez le notaire pour une PMA',
        href: 'https://clotere.framer.website/blog/demarches-chez-le-notaire-pour-une-pma',
        imageUrl:
            'https://framerusercontent.com/images/DlQrHBD7UTZEiVawVV67NMIsw.jpeg',
        category: { title: 'Démarches notaire PMA' },
    },
]

function Pma(args) {
    return (
        <>
            <Helmet>
                <title>Trouver votre notaire pour vos actes notariés de PMA</title>
                <meta name="robots" content="index,follow" />
                <meta name="googlebot" content="index,follow" />
                <meta name='description' content='Clotere.fr vous aide à trouver votre notaire pour vos documents notariés dans le cadre de votre PMA : Consentement à la PMA et,  reconnaissance conjointe anticipée dans le cadre d/une PMA.' />
                <meta property="og:url" content="https://clotere.fr/notaire-pma" />
                <meta property="og:site_name" content="Clotere" />
                <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
                <meta property="og:type" content="website" />
            </Helmet>

            {/**header 2 */}
            <div className="relative rounded-4xl ">
                <BackHeaderTop />
                <Navbar user={args.user} />

                <div className="relative container ">
                    {/** header */}
                    <header class="flex flex-row flex-wrap justify-center sm:py-10 items-center">
                        <div className="w-full sm:basis-1/2 p-3 sm:p-4 flex flex-col sm:gap-6 text-center">
                            <h1 className="font-medium text-transparent sm:!text-[60px] tracking-[0]  mb-0" >
                                <span className=" text-black">PMA et parentalité : <span className="font-bold mt-2 text-indigo-800"> un notaire engagé à vos côtés</span> </span>
                            </h1>

                            <p className="text-lg font-semibold leading-7 sm:w-[80%] mb-0 mx-auto">
                                Reconnaissance conjointe, autorité parentale, filiation : Clotere vous connecte à un notaire et vous aide à tout formaliser sereinement en vous accompagnant de A à Z.
                            </p>

                            {/** bloc bouton */}
                            <div>
                                <Link to="/onboard/pma"
                                    type="button"
                                    className=" box-content mt-3 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Trouver mon notaire
                                    <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                </Link>
                                <div className="flex flex-row gap-4 items-center mt-2 justify-center">
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4 flex" />
                                        5 minutes
                                    </div>
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4" />
                                        1er rdv gratuit
                                    </div>
                                </div>
                            </div>

                            {/**bloc avis */}
                            <div>
                                <div className="flex gap-2 items-center  justify-center">
                                    <img src={GoogleAvis2} className="w-32" alt="Notaire en ligne" />
                                    <p className="m-0 text-sm font-bold">5 | <a target="blank" href="https://www.google.com/search?sca_esv=d214253f9e079b85&hl=fr&authuser=0&q=Clotere&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZDzCaQ6PPw1Mgvvzif6RPDbzlyvfgpBpItJUodOtpKTPaOfRqxPnJiVlFGA37fDf9TtdoQ%3D&uds=ABqPDvysoTTq_vp6PiQY3u-nn8x5mrrThE-WixzhGgTgcP_mlCE3-A4gQLqOtz9y4LiiTIbfFBKkE3gMtki_Kkb4BD_mskaVaRvCLgFEWxykHDgiwrX4QIM&sa=X&ved=2ahUKEwjSoubx5s2MAxUaTqQEHXPXOdUQ3PALegQIGhAE&biw=1511&bih=765&dpr=2" className="text-black !font-normal">8 avis</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="w-full sm:basis-1/2 p-0 lg:p-5  sm:flex bg-transparent overflow-hidden rounded-2xl">
                            <img className="object-cover" src={PmaImg} alt="Vos démarches chez le notaire pour vos démarches de PMA" />

                        </div>
                    </header>
                </div>

                <BackHeaderBottom />
                {/** bloc ccm */}
                <section className="">
                    <div className="container">
                        <div className="py-12">
                            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-4 sm:gap-y-16 lg:max-w-none lg:grid-cols-4 justify-center">
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <ChatBubbleBottomCenterIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Parlez avec votre notaire gratuitement</p>
                                        <p className=" text-base mb-0">Un 1er rendez-vous gratuit avec votre notaire dès l'ouverture de votre dossier.</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <DocumentCheckIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Des étapes chez le notaire simples</p>
                                        <p className=" text-base mb-0">Renseignez vos informations et déposez vos documentse, en toute sécurité. </p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <CurrencyEuroIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Vos droits, et obligations en toute transparence </p>
                                        <p className=" text-base mb-0">On vous explique et on vous rappelle l’essentiel : filliation, obligations légales...etc</p>

                                    </dd>
                                </div>

                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <ScaleIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Et si vous avez des questions ?</p>
                                        <p className=" text-base mb-0">En plus de votre notaire, un conseiller dédié Clotere vous réponds, sur whatsapp chat ou mail 24/24.</p>

                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </section>

                <AccompagnementClotere />
            </div>

            {/** section FAQ */}
            <FaqPma />

            {/** section Blog */}
            <section class=" mt-4 mb-4 flex flex-row flex-wrap justify-center items-center">
                <div className="bg-white sm:py-20 ">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto text-center">
                            <h2 className="title-clotere">Bien comprendre votre passage chez le notaire pour <span className="font-bold text-indigo-800">votre consentement à la PMA</span> et <span className="font-bold text-indigo-800">votre reconnaissance conjointe d'enfant (PMA)</span></h2>

                        </div>
                        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-4 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-4 ">
                            {posts.map((post) => (
                                <article key={post.id} className="flex flex-col items-start gap-2 sm:gap-8 justify-center overflow-hidden bg-white shadow rounded-lg p-3">
                                    <p className="font-bold text-indigo-600 hover:bg-gray-100 m-0">{post.category.title} </p>

                                    <h3 className="mt-3 text-xl  font-semibold leading-7 text-gray-900 group-hover:text-gray-600">

                                        {post.title}

                                    </h3>

                                    <a href={post.href} target='blank' className="btn-primary no-underline">Lire l'article</a>

                                </article>
                            ))}
                        </div>
                        <div className="mx-auto max-w-2xl text-center">
                            <Link to="/blog/notaire-et-pma"
                                type="button"
                                className="mt-5 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Consultez nos guides notaire et PMA
                                <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                            </Link>
                        </div>


                    </div>

                </div>

            </section>

            <PrendreRdv />
            <Footer />
        </>
    );
}

export default Pma;